import { render, staticRenderFns } from "./GroupMerchant.vue?vue&type=template&id=275ba3c1"
import script from "./GroupMerchant.vue?vue&type=script&lang=js"
export * from "./GroupMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports